import moment from 'moment';
import { MONTHS } from '../constants/commonData';
import { getLastDayQuinzaine } from './suitableDate';

const quinzDiff = (d1, d2) => {
  const quinz = Math.round(d2.diff(d1, 'days') / 15);
  return quinz <= 0 ? 1 : quinz;
};
export const createSelectionPeriode = (launchingDate, lastDate = getLastDayQuinzaine(moment())) => {
  const nbQuinz = launchingDate ? quinzDiff(launchingDate, lastDate) : 1;
  const returnSelection = {};
  const currentYear = lastDate.get('year');
  const usefullDate = lastDate;
  let periode = usefullDate.get('date') < 16 ? '1ère' : '2ème';

  for (let i = 0; i < nbQuinz; i++) {
    const month = usefullDate.get('month') + 1;
    const objectPeriode = {
      toShow: `${MONTHS[usefullDate.get('month')]}, ${periode} quinzaine`,
      quinzaine: periode === '1ère' ? '01' : '16',
      month: month > 9 ? month : `0${month}`
    };

    if (!returnSelection[usefullDate.get('year')]) {
      returnSelection[usefullDate.get('year')] = [];
    }
    returnSelection[usefullDate.get('year')].push(objectPeriode);

    if (periode === '1ère' && nbQuinz > i) {
      usefullDate.set('month', usefullDate.get('month') - 1);
    }
    periode = periode === '1ère' ? '2ème' : '1ère';
  }
  return {
    optionFinance: returnSelection,
    periode: returnSelection[currentYear][0].toShow,
    currentYear
  };
};
export const feesCalculs = (financeTableau, stripeTableau, fees) => {
  let feesObj = {};
  if (fees && Object.keys(fees).length > 0) {
    Object.keys(fees).forEach(fee => {
      const { fixe, variable } = fees[fee];
      let fraisVar = 0;
      let fraisFixe = 0;
      if (fee === 'stripe') {
        fraisFixe = Math.round(stripeTableau[3].cost * fixe * 1.2 * 100) / 100;
        fraisVar =
          Math.round(
            (stripeTableau[0].cost *
              1.2 *
              (variable === 0 || !variable ? 0 : variable.split('%')[0])) /
            1.1
          ) / 100;
      } else {
        fraisFixe = Math.round(financeTableau[3].cost * fixe * 100) / 100;
        fraisVar =
          Math.round(
            (financeTableau[0].cost * (variable === 0 || !variable ? 0 : variable.split('%')[0])) /
            1.1
          ) / 100;
      }
      feesObj = {
        ...feesObj,
        [fee]: {
          fraisVar,
          fraisFixe
        }
      };
    });
  }
  return feesObj;
};

export const getFirstAndLastDate = (quinzaine, month, year) => {
  const firstDate = quinzaine === '16' ? `${year}-${month}-16` : `${year}-${month}-01`;
  const lastDate =
    quinzaine === '16'
      ? moment(`${year}/${month}/16`)
        .add(1, 'M')
        .startOf('month')
        .format('YYYY-MM-DD')
      : `${year}-${month}-16`;
  return { firstDate, lastDate };
};
